import { render } from "./HeroWice.vue?vue&type=template&id=1c4d1a05&scoped=true"
import script from "./HeroWice.vue?vue&type=script&lang=js"
export * from "./HeroWice.vue?vue&type=script&lang=js"

import "./HeroWice.vue?vue&type=style&index=0&id=1c4d1a05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d1a05"]])

export default __exports__